import { render, staticRenderFns } from "./Botones.vue?vue&type=template&id=2fa95080&scoped=true&lang=pug"
import script from "./Botones.vue?vue&type=script&lang=js"
export * from "./Botones.vue?vue&type=script&lang=js"
import style0 from "./Botones.vue?vue&type=style&index=0&id=2fa95080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa95080",
  null
  
)

export default component.exports